import { render, staticRenderFns } from "./batch-close.vue?vue&type=template&id=798852dd&scoped=true"
import script from "./batch-close.ts?vue&type=script&lang=ts&external"
export * from "./batch-close.ts?vue&type=script&lang=ts&external"
import style0 from "./batch-close.scoped.scss?vue&type=style&index=0&id=798852dd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798852dd",
  null
  
)

export default component.exports